import { render, staticRenderFns } from "./deliveryRecord.vue?vue&type=template&id=6b12631c&scoped=true&"
import script from "./deliveryRecord.vue?vue&type=script&lang=js&"
export * from "./deliveryRecord.vue?vue&type=script&lang=js&"
import style0 from "./deliveryRecord.vue?vue&type=style&index=0&id=6b12631c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12631c",
  null
  
)

export default component.exports